import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import '@morefunos/ui/tokens.css';
import '@morefunos/ui/base.css';
import '@morefunos/ui/mobile-ordering.css';
import './customer.css';
import {App} from './App.tsx';
import {createCustomerComboPort} from './customer-combo-port.ts';
import {resolveCustomerRuntimeHost} from './runtime.ts';

const root = document.getElementById('root');
if (!root) throw new Error('CUSTOMER_ROOT_REQUIRED');
const host = resolveCustomerRuntimeHost();
let sequence = 0;
const port = host ? createCustomerComboPort({
  runtime: host.runtime,
  catalog: host.catalog,
  businessDate: host.businessDate,
  now: () => new Date().toISOString(),
  nextId: (kind) => `${kind}:${globalThis.crypto?.randomUUID?.() ?? `${Date.now()}:${++sequence}`}`,
}) : null;

createRoot(root).render(<StrictMode><App
  port={port}
  paymentProofUpload={host?.paymentProofUpload}
  businessDate={host?.businessDate}
/></StrictMode>);
